import { useTranslation } from 'react-i18next';

import { StatusBadge } from '@treezor/design-system';

import { walletStatusColors, walletStatusList } from '@/features/wallets/store/models/wallet.model';

export interface IWalletStatusProps {
  status: keyof typeof walletStatusList;
}

export function WalletStatus({ status }: IWalletStatusProps) {
  const { t } = useTranslation();

  return (
    <StatusBadge color={walletStatusColors[status]} label={t(`monetics.wallet.status.${status}`)} emphasis="low" />
  );
}
